import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

import { Tabs } from "@/lib/components/ui/Tabs/Tabs";
import { PATHS } from "@/lib/config/routesConfig";
import { useSetPageHeader } from "@/lib/context/PageHeaderProvider";

import styles from "./page.module.scss";

const PAGES = [
  { id: "table", path: PATHS.TABLE, label: "overviewTable" },
  { id: "analytics", path: PATHS.ANALYTICS, label: "tabAnalytics" },
] as const;

export const OverviewRedirect = ({ to }: { to: string }): JSX.Element => {
  const { search, hash } = useLocation();

  return <Navigate to={`${to}${search}${hash}`} replace />;
};

export const OverviewLayout = (): JSX.Element => {
  const { t } = useTranslation("translation");
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const activePage =
    PAGES.find((page) => pathname.startsWith(page.path)) ?? PAGES[0];
  useSetPageHeader({ title: t("tabOverview") }, [t]);

  return (
    <div className={styles.page} data-test="overview-page">
      <Tabs
        ariaLabel={t("tabOverview")}
        dataTest="overview-tabs"
        tabList={PAGES.map((page) => ({
          id: `overview-tab-${page.id}`,
          panelId: "overview-content",
          dataTest: `overview-tab-${page.id}`,
          label: t(page.label),
          isSelected: activePage.id === page.id,
          onClick: () => navigate(page.path),
        }))}
      />
      <div
        id="overview-content"
        role="tabpanel"
        aria-labelledby={`overview-tab-${activePage.id}`}
        tabIndex={0}
        className={styles.content}
        data-test={`overview-content-${activePage.id}`}
      >
        <Outlet />
      </div>
    </div>
  );
};
